import { QueryClient } from "@tanstack/react-query";

// The orders workspace is deliberately cache-first.  Background reconciliation
// keeps it current, while opening a row must never wait for a network request.
export const ORDER_CACHE_TIME = 30 * 24 * 60 * 60 * 1000;
export const ORDER_DETAILS_STALE_TIME = 30_000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ORDER_DETAILS_STALE_TIME,
      gcTime: ORDER_CACHE_TIME,
      retry: (count, error) => {
        const status =
          error && typeof error === "object" && "status" in error
            ? Number(error.status)
            : 0;
        return status !== 401 && status !== 403 && count < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
